var React = require('react');

function ChevronRightStroke (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M3.646 10.354a.5.5 0 01-.057-.638l.057-.07L7.293 6 3.646 2.354a.5.5 0 01-.057-.638l.057-.07a.5.5 0 01.638-.057l.07.057 4 4a.5.5 0 01.057.638l-.057.07-4 4a.5.5 0 01-.708 0z"}));
}

ChevronRightStroke.defaultProps = {"width":"12","height":"12","focusable":"false","viewBox":"0 0 12 12"};

module.exports = ChevronRightStroke;

ChevronRightStroke.default = ChevronRightStroke;
